// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"190":"dafa817e","537":"87cc5163","555":"1ab6dd59","617":"8b9a4c8f","705":"1ab6dd59"}[chunkId] + ".chunk.css";
};